import { render, staticRenderFns } from "./BaseSearchInput.vue?vue&type=template&id=3574e3fd&scoped=true&"
import script from "./BaseSearchInput.vue?vue&type=script&lang=js&"
export * from "./BaseSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchInput.vue?vue&type=style&index=0&id=3574e3fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574e3fd",
  null
  
)

export default component.exports